/**
 * Created by m.igrachev on 4/18/2016.
 */
import React from "react";
import PropTypes from "prop-types";
import documentedProps from "./documentation/HeadingDocumentedProps";

import("./Heading.less");

var splitterTypes = {
    light: " tq-light-splitter",
    heavy: " tq-heavy-splitter"
};

export default class Heading extends React.Component {
    filterChildren() {
        var result = { actionMenu: null, icons: [] };
        React.Children.forEach(this.props.children, (child, index) => {
            if (!React.isValidElement(child)) return;

            const displayName = child.type.displayName || child.type.name;
            if (displayName.includes("ActionMenu")) {
                result.actionMenu = child;
            }
            if (displayName.includes("Icon")) {
                result.icons.push(child);
            }
        });

        return result;
    }

    computeClass() {
        var className = this.props.subtitle ? " tq-sub-title" : " tq-panel-title";
        className += this.props.textColor ? " " + this.props.textColor : "";
        if (this.props.splitter) {
            var chosenSplitter = splitterTypes[this.props.splitter];
            className += chosenSplitter ? " " + chosenSplitter : "";
        }

        if (this.props.expandable) {
            className += " tq-expandable-title";
        }

        if (this.props.fontStyles) {
            for (let fontStyle of this.props.fontStyles) {
                className += " tq-" + fontStyle;
            }
        }

        return className;
    }

    render() {
        var extraClasses = this.props.extraClasses || "";
        var className = extraClasses + this.computeClass();

        var allowedChildren = this.filterChildren();

        var icons = allowedChildren.icons.length ? allowedChildren.icons : null;

        if (allowedChildren.actionMenu) {
            className += " tq-with-right-menu";
        }

        let customContent = [];
        let index = 0;
        if (this.props.customContent) {
            for (let contentItem of this.props.customContent) {
                customContent.push(React.cloneElement(contentItem, { key: index++ }));
            }
        }

        return (
            <h3 className={className} data-tq-id={this.props.dataTqId}>
                {!this.props.customContent && this.props.leftIcon && (
                    <a>
                        <i className={this.props.leftIcon} />
                    </a>
                )}
                {!this.props.customContent && (
                    <span className="tq-text-node">
                        {this.props.title}
                        {icons}
                    </span>
                )}
                {this.props.customContent && customContent}
                {allowedChildren.actionMenu}
            </h3>
        );
    }
}

Heading.displayName = "Heading";

Heading.propTypes = {
    title: PropTypes.string,
    textColor: PropTypes.string, //Note so far we directly add the color to the className however we can make mapping if needed.
    leftIcon: PropTypes.string,
    splitter: PropTypes.string,
    extraClasses: PropTypes.string,
    subtitle: PropTypes.bool,
    expandable: PropTypes.bool,

    customContent: PropTypes.arrayOf(PropTypes.element),
    dataTqId: PropTypes.string
};

Heading.documentedProps = documentedProps;
